import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
import * as R from 'ramda'
import { select, store } from '../store'

interface INotificationState {
  [notificationId: string]: INotification
}

export default createModel({
  state: {} as INotificationState,
  reducers: {
    updateById: (state: INotificationState, payload: { notificationId: string, notification: INotification }): INotificationState => ({
      ...state, [payload.notificationId]: payload.notification
    }),
  },
  effects: {
    async fetchNotifications() {
      const currentUser = firebase.auth().currentUser
      const userId = currentUser ? currentUser.uid : null
      const notificationsRef = await firebase.firestore().collection('notifications').where('userId', '==', userId).get()
      notificationsRef.docs.map(doc => {
        const notificationId = doc.id
        const notification = doc.data() as INotification
        this.updateById({ notificationId, notification })
      })
    },
    async updateNotification(payload: { notificationId: string, updated: Partial<INotification> }) {
      const { notificationId, updated } = payload
      const notification = select.notifications.getById(store.getState(), notificationId)
      const updatedNotification = {
        ...notification, ...updated
      }
      firebase.firestore().collection('notifications').doc(notificationId).set(updatedNotification)
      this.updateById({ notificationId, notification: updatedNotification })
    },
  },
  selectors: {
    getById: (state: INotificationState, notificationId: string) => {
      return state[notificationId] ? state[notificationId] : null
    },
    getNotifications: (state: INotificationState) => {
      const notificationPayloads = R.keys(state).map(notificationId => ({
        notificationId: notificationId as string, notification: state[notificationId]
      }))
      return R.reverse(R.sortBy(payload => payload.notification.ts.toDate(), notificationPayloads))
    },
  }
})


// WEBPACK FOOTER //
// ./src/models/notifications.ts